import axios, { AxiosError } from "axios";
import { useContext } from "react";
import useSWR from "swr";
import { pollingInterval } from "../../../constants/pollingInterval";
import { AuthContext } from "../../../context/AuthContext";
import { AdminEndpointEnum } from "../../../enums/endpoints";
import { DEGEN_API_URL } from "../../../utils/env";

export enum TradeTypeEnum {
    TRADE = "trade",
    LIQUIDATION = "liquidation",
    SETTLEMENT = "settlement",
    FUNDING = "funding",
  }

export interface IDegenTransaction {
  AccountId: string;
  Amount: string;
  Fee: string;
  Collateral: string;
  CollateralName: string;
  TxType: string;
  L2TxHash: string;
  OriginTxHash: string;
  ChainId: string;
  Label: string;
  Status: string;
  _CreatedTimestamp: string;
  _SeqNo: string;
}

export interface IDegenStat {
  value: string;
  label: string;
  description: string;
}

export interface IDegenStats {
  totalDeposit?: IDegenStat;
  totalWithdraw?: IDegenStat;
  equity?: IDegenStat;
  asset?: IDegenStat;
  liability?: IDegenStat;
}

export interface IDegenTransactionsResponse {
  ok: boolean;
  data: IDegenTransaction[];
  count?: number;
  totalWithdrawAmount?: string;
  stats?: IDegenStats;
}

export const useAccountDegenTransactions = () => {
  const { tokenId } = useContext(AuthContext);

  const endpoint = DEGEN_API_URL();
  const swr = useSWR<IDegenTransactionsResponse, AxiosError>(
    tokenId ? [endpoint, tokenId] : undefined,
    async () => {
      const response = await axios.get<IDegenTransactionsResponse>(endpoint, {
      });

      const { data } = response;

      // Sort by timestamp descending (most recent first)
      if (data.data) {
        // eslint-disable-next-line no-underscore-dangle
        data.data.sort((a, b) => Number(b._CreatedTimestamp) - Number(a._CreatedTimestamp));
      }

      return data;
    },
    {
      refreshInterval: pollingInterval[AdminEndpointEnum.ACCOUNT],
    }
  );

  return {
    ...swr,
  };
};
